module.exports = __webpack_public_path__ + "media/images/unpublish_icon-7016a864eb68df4710fe0d0a0ab05d2f.png";